import React, { Component } from "react";
import { css } from "aphrodite/no-important";
import { styles } from "../components/AlertSettingsStyles";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { connect } from "react-redux";
import SuccessMessage from "../components/SuccessMessage";
import ErrorMessage from "../components/ErrorMessage";

export const alert_notification = {
  0: {
    alert_sms: false,
    alert_email: false
  },
  1: {
    alert_sms: false,
    alert_email: true
  },
  2: {
    alert_sms: true,
    alert_email: false
  },
  3: {
    alert_sms: true,
    alert_email: true
  }
};

const validate = (values, allValues) => {
  const errors = {};

  if (!values.alert_email && !values.alert_sms) {
    errors.hidden_field =
      "Please select either email, sms, or both. During the trial you must have at least one option selected.";
  }

  return errors;
};

let AlertSettings = (props) => {
  const renderError = (props) => {
    const {
      meta: { touched, error, warning }
    } = props;
    return (
      <div>
        {touched &&
          ((error && <span className={css(styles.error)}>{error}</span>) ||
            (warning && <span>{warning}</span>))}
      </div>
    );
  };
  const renderCheckbox = (props) => {
    return (
      <span>
        <div className={css(styles.checkboxWrapper)}>
          <div className={css([styles.checkbox, props.input.checked && styles.checkboxChecked])}>
            <img className={css(styles.checkboxIcon)} src={"/icons/check.svg"} />
          </div>
          <strong className={css(styles.label)}>{props.label}</strong>
        </div>
        <input className={css(styles.hidden)} {...props.input} type={props.type} />
      </span>
    );
  };
  const { handleSubmit, submit, submitSucceeded, submitFailed } = props;

  return (
    <form onSubmit={handleSubmit}>
      <h2 className={css(styles.header2)}>Alert Settings</h2>
      <p className={css(styles.microcopy)}>How would you like to receive alerts?</p>
      <div>
        <label>
          <Field
            name="alert_email"
            component={renderCheckbox}
            type="checkbox"
            value="email"
            label={"Email"}
            onChange={(e) => {
              setTimeout(() => {
                submit("alert-settings");
              }, 500);
            }}
          />
        </label>
        <label>
          <Field
            name="alert_sms"
            component={renderCheckbox}
            type="checkbox"
            value="sms"
            label={"SMS"}
            onChange={() => {
              setTimeout(() => {
                submit("alert-settings");
              }, 500);
            }}
          />
        </label>
        <div>
          <Field name="hidden_field" component={renderError} />
        </div>
        {submitSucceeded && <SuccessMessage message="Preference saved" />}
        {submitFailed && <ErrorMessage message="Could not save preference" />}
      </div>
    </form>
  );
};

const mapStateToProps = (state) => {
  const initialValues = state.account.accountDetail[1] && alert_notification[state.account.accountDetail[1].alert_notification];
  return {
    initialValues,
    account: state.account
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "alert-settings",
    validate
  })(AlertSettings)
);
